import styled from "styled-components";

export const SuperAdminStyledDiv = styled.div`
	@keyframes scroll-text {
		0% {
			transform: translateX(0%);
		}
		90% {
			transform: translateX(-100%);
		}
		95% {
			transform: translateX(0%);
		}
		100% {
			transform: translateX(0%);
		}
	}

	.animate-scroll-text {
		animation: scroll-text 7s linear infinite;
	}

	.one-line {
		width: 100%;
		white-space: nowrap;
		overflow: hidden;

		&:not(:hover) {
			text-overflow: ellipsis;
		}

		&:hover,
		&:focus {
			span {
				display: inline-block;
				animation-name: scroll-text;
				animation-duration: 7s;
				animation-timing-function: linear;
				animation-delay: 0s;
				animation-iteration-count: infinite;
				animation-direction: normal;
			}
		}

		@keyframes scroll-text {
			0% {
				transform: translateX(0%);
			}
			90% {
				transform: translateX(-100%);
			}
			95% {
				transform: translateX(0%);
			}
			100% {
				transform: translateX(0%);
			}
		}
	}
`;
